/* eslint-disable */

export const editBotConstants = {
    EDIT_BOT_REQUEST: 'EDIT_BOT_REQUEST',
    EDIT_BOT_SUCCESS: 'EDIT_BOT_SUCCESS',
    EDIT_BOT_FAILURE: 'EDIT_BOT_FAILURE',
};
